/**
 * @flow
 * @relayHash 0e29e31154071bae02047f3e565d9f4e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UploadGpxFileInput = {|
  email?: ?string,
  file: any,
|};
export type UploadGpxFileMutationVariables = {|
  input: UploadGpxFileInput
|};
export type UploadGpxFileMutationResponse = {|
  +uploadGpxFile: ?{|
    +gpxFile: ?{|
      +id: string
    |}
  |}
|};
export type UploadGpxFileMutation = {|
  variables: UploadGpxFileMutationVariables,
  response: UploadGpxFileMutationResponse,
|};
*/


/*
mutation UploadGpxFileMutation(
  $input: UploadGpxFileInput!
) {
  uploadGpxFile(input: $input) {
    gpxFile {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UploadGpxFileInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "uploadGpxFile",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UploadGpxFilePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "gpxFile",
        "storageKey": null,
        "args": null,
        "concreteType": "GpxFile",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UploadGpxFileMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UploadGpxFileMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UploadGpxFileMutation",
    "id": null,
    "text": "mutation UploadGpxFileMutation(\n  $input: UploadGpxFileInput!\n) {\n  uploadGpxFile(input: $input) {\n    gpxFile {\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cf831d103c0daf6474786b897925f6a4';

module.exports = node;
